import React, {useEffect, useState} from 'react';
import { Row, Col } from '@zendeskgarden/react-grid';
import styled from 'styled-components/macro';
import { map } from 'lodash';
import ImageGallerySlider from 'components/RelatedProductsSlider/ImageGallerySlider'
import InPageOverlay from 'components/InPageOverlay/InPageOverlay';

const ExtraWrapperStyled = styled.div`
`;

const ImageRow = styled(Row)`
  
`;


const ImageCol = styled(Col)`
  margin-bottom: 20px;
  flex-wrap: wrap;
`;


const Image = styled.div`
  width: 100%;
  height: 150px;
  position: relative;
  width: 100%;
  overflow: hidden;
  border-radius: 0px;  
  background-color: rgb(255, 255, 255);
  background-size: cover;
`;


const ImageGalleryImage = ({onClick, images}) => {
  const [inPageOverlayViewOpen, setInPageOverlay] = useState(-1);

  return (
    <ExtraWrapperStyled>
      <ImageRow>
        {
          map(images, (img, i) => {
            return (
              <ImageCol onClick={() => setInPageOverlay(i)} md={4} lg={3} size={6} key={i}>
                <Image style={{backgroundImage: `url(${img.image})`}} />
              </ImageCol>
            )
          })
        }
      </ImageRow>

      <InPageOverlay portal onClose={() => setInPageOverlay(-1)} open={inPageOverlayViewOpen !== -1}>
        <ImageGallerySlider active={inPageOverlayViewOpen} data={images}/>
      </InPageOverlay>
    </ExtraWrapperStyled>
  )
}


export default ImageGalleryImage
